import React from "react";
import "./Award.css";

const Award = () => {
  return (
    <div className="awards-container">
		<p className='section-highlight'>Awarded</p>
		<h1 className='section-heading'>Best Forex Broker Award </h1>
      <div className="awards-card">
        <img src="/images/forex-award.jpg" alt="Award Trophy" className="awards-image" />
        <h2 className="awards-title">Excellence Award 2023</h2>
        <p className="awards-description">
          We are honored to receive the <strong>Excellence Award 2023 </strong> 
          for outstanding performance in innovation and customer satisfaction. 
          Recognized globally, we continue to set new industry benchmarks.
        </p>
      </div>
    </div>
  );
};

export default Award;
